"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const react_dom_1 = require("react-dom");
const react_1 = require("react");
const clsx_1 = require("clsx");
const core_1 = require("@popperjs/core");
const DayPicker_1 = __importDefault(require("./sub-component/DayPicker"));
const TextField_1 = __importDefault(require("../input/TextField"));
const FontIcon_1 = __importDefault(require("../icon/FontIcon"));
const matchDayUtils_1 = require("./utils/matchDayUtils");
const eventUtils_1 = require("../common/eventUtils");
const propTypesUtils_1 = require("./utils/propTypesUtils");
const dateConstants_1 = require("./utils/dateConstants");
const dateUtils_1 = require("./utils/dateUtils");
const date_fns_1 = require("date-fns");
class DatePicker extends react_1.Component {
    constructor(props) {
        super(props);
        this.refPicker = null;
        this.dayPickerInstance = null;
        const { date, format, initialMonth, locale } = props;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const getLocale = require(`date-fns/locale/${locale || 'en-US'}/index.js`);
        this.state = {
            navigationDate: initialMonth || this.computeDate(date) || new Date(),
            locale: getLocale,
            inputValue: this.computeDate(date)
                ? (0, date_fns_1.format)(date, format, { locale: getLocale })
                : null,
            showPicker: false,
            refIcon: (0, react_1.createRef)(),
            refContainer: null,
            popperElement: null,
            referenceElement: null,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleKeyDownIcon = this.handleKeyDownIcon.bind(this);
        this.handleKeyDownInput = this.handleKeyDownInput.bind(this);
        this.handleOnClose = this.handleOnClose.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setRefContainer = this.setRefContainer.bind(this);
        this.setPopperElement = this.setPopperElement.bind(this);
        this.setReferenceElement = this.setReferenceElement.bind(this);
        this.mountDayPickerInstance = this.mountDayPickerInstance.bind(this);
        this.unmountDayPickerInstance = this.unmountDayPickerInstance.bind(this);
        this.handleScrollParent = this.handleScrollParent.bind(this);
        this.handleKeydownScrollParent = this.handleKeydownScrollParent.bind(this);
    }
    componentDidMount() {
        const { onInit, date } = this.props;
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.showOverlay && !this.props.menuPortalTarget) { // doesn't open if inside a portal
            this.setState({ showPicker: true });
        }
        if (onInit && date) {
            onInit(this.computeDate(date));
        }
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.showPicker && !prevState.showPicker) {
            this.mountDayPickerInstance();
            this.handleFocusToSelectedDate();
            this.props.onCalendarOpen && this.props.onCalendarOpen(this.props.id);
        }
        else if (!this.state.showPicker && prevState.showPicker) {
            this.unmountDayPickerInstance();
            this.props.onCalendarClose && this.props.onCalendarClose(this.props.id);
            if (this.props.shouldResetInvalidDate) {
                const validDate = this.props.date && this.props.date;
                this.setState({
                    navigationDate: validDate || new Date(),
                    inputValue: this.computeDate(validDate)
                        ? (0, date_fns_1.format)(validDate, this.props.format, {
                            locale: this.state.locale,
                        })
                        : null,
                });
            }
        }
        // update dynamically if locale change
        if (this.props.locale !== prevProps.locale) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const getLocale = require(`date-fns/locale/${this.props.locale || 'en-US'}/index.js`);
            this.setState({
                locale: getLocale,
                inputValue: this.computeDate(this.props.date)
                    ? (0, date_fns_1.format)(this.props.date, this.props.format, {
                        locale: getLocale,
                    })
                    : null,
            });
        }
    }
    /**
     * Reset to default value and reset errors
     */
    reset(date) {
        const { format, onChange, onValidationChanged } = this.props;
        const { locale } = this.state;
        if (onValidationChanged) {
            onValidationChanged(null);
        }
        if (onChange) {
            onChange({ target: { value: date } });
        }
        this.setState({
            inputValue: this.computeDate(date)
                ? (0, date_fns_1.format)(date, format, { locale: locale })
                : null,
        });
    }
    handleClickOutside(event) {
        const { popperElement, refContainer, showPicker } = this.state;
        if (refContainer &&
            !refContainer.contains(event.target) &&
            popperElement &&
            !popperElement.contains(event.target)) {
            const { date, onBlur } = this.props;
            if (showPicker) {
                this.setState({ showPicker: false });
                if (onBlur) {
                    onBlur({
                        target: {
                            value: date,
                        },
                    });
                }
            }
        }
    }
    setRefContainer(node) {
        this.setState({ refContainer: node });
    }
    setPopperElement(node) {
        this.setState({ popperElement: node });
    }
    setReferenceElement(node) {
        this.setState({ referenceElement: node });
    }
    mountDayPickerInstance() {
        const { placement, menuShouldBlockScroll } = this.props;
        const { popperElement, referenceElement, refContainer } = this.state;
        this.dayPickerInstance = (0, core_1.createPopper)(referenceElement, popperElement, {
            placement: `${placement}-start`,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-start', 'right-start', 'left-start'],
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 4],
                    },
                },
            ],
        });
        if (menuShouldBlockScroll) {
            const scrollContainer = (0, eventUtils_1.getScrollParent)(refContainer);
            if (scrollContainer) {
                const wheelEvent = eventUtils_1.EventListener.onwheel in document.createElement('div') ? eventUtils_1.EventListener.wheel : eventUtils_1.EventListener.mousewheel;
                scrollContainer.addEventListener(eventUtils_1.EventListener.DOMMouseScroll, this.handleScrollParent); // older Firefox
                scrollContainer.addEventListener(eventUtils_1.EventListener.touchmove, this.handleScrollParent); // mobile
                scrollContainer.addEventListener(wheelEvent, this.handleScrollParent); // modern desktop
                scrollContainer.addEventListener(eventUtils_1.EventListener.keydown, this.handleKeydownScrollParent);
            }
        }
    }
    unmountDayPickerInstance() {
        const { menuShouldBlockScroll } = this.props;
        const { refContainer } = this.state;
        if (this.dayPickerInstance) {
            this.dayPickerInstance.destroy();
            Reflect.deleteProperty(this, 'dayPickerInstance');
            if (menuShouldBlockScroll) {
                const scrollContainer = (0, eventUtils_1.getScrollParent)(refContainer);
                if (scrollContainer) {
                    const wheelEvent = eventUtils_1.EventListener.onwheel in document.createElement('div') ? eventUtils_1.EventListener.wheel : eventUtils_1.EventListener.mousewheel;
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.DOMMouseScroll, this.handleScrollParent);
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.touchmove, this.handleScrollParent);
                    scrollContainer.removeEventListener(wheelEvent, this.handleScrollParent);
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.keydown, this.handleKeydownScrollParent);
                }
            }
        }
    }
    computeDate(date) {
        const { disabledDays } = this.props;
        if (date && (0, date_fns_1.isValid)(date) && !(0, matchDayUtils_1.matchDay)(date, disabledDays)) {
            return date;
        }
        else {
            return null;
        }
    }
    computeError(date) {
        const { disabledDays } = this.props;
        if (!date) {
            return null;
        }
        if (!(0, date_fns_1.isValid)(date)) {
            return { format: 'The date format is incorrect' };
        }
        else if ((0, matchDayUtils_1.matchDayMax)(date, disabledDays)) {
            return { maxDate: 'Date too far in the future' };
        }
        else if ((0, matchDayUtils_1.matchDayMin)(date, disabledDays)) {
            return { minDate: 'Date too far in the past' };
        }
        else if ((0, matchDayUtils_1.matchDay)(date, disabledDays)) {
            return { disabledDate: 'This date is not available' };
        }
        else {
            return null;
        }
    }
    handleFocusToSelectedDate() {
        const selectedDate = this.state.navigationDate ? this.state.navigationDate.getDate() : new Date().getDate();
        if (this.refPicker && this.refPicker.dayPicker) {
            const dayNodes = this.refPicker.dayPicker.querySelectorAll(dateConstants_1.DAYS_VISIBLE_SELECTOR);
            const dateNode = dayNodes[selectedDate - 1];
            if ((dateNode === null || dateNode === void 0 ? void 0 : dateNode.tabIndex) === 0) {
                // Only focus to current date or selected date when opening the date picker
                dateNode === null || dateNode === void 0 ? void 0 : dateNode.focus();
            }
        }
    }
    handleScrollParent(e) {
        if (this.state.showPicker) {
            (0, eventUtils_1.cancelEvent)(e);
        }
    }
    handleKeydownScrollParent(e) {
        const scrollingKeys = [eventUtils_1.Keys.PAGE_UP, eventUtils_1.Keys.PAGE_DOWN, eventUtils_1.Keys.HOME, eventUtils_1.Keys.END, eventUtils_1.Keys.ARROW_UP, eventUtils_1.Keys.ARROW_DOWN];
        if (this.state.showPicker) {
            if (scrollingKeys.includes(e.key)) {
                (0, eventUtils_1.cancelEvent)(e);
            }
        }
    }
    async handleDayClick(date, modifiers) {
        const { format, onChange, onValidationChanged } = this.props;
        const { locale } = this.state;
        if (modifiers.disabled) {
            return;
        }
        const newDate = modifiers.selected ? undefined : date;
        const inputValue = (0, date_fns_1.format)(date, format, { locale: locale });
        this.setState({
            navigationDate: newDate,
            inputValue: modifiers.selected ? undefined : inputValue,
            showPicker: false,
        });
        if (onValidationChanged) {
            onValidationChanged(this.computeError(newDate));
        }
        if (onChange) {
            onChange({
                target: { value: newDate },
            });
        }
    }
    handleInputChange(e) {
        const { format, onChange, onValidationChanged } = this.props;
        const { locale } = this.state;
        const newValue = e.target.value;
        this.setState({ inputValue: newValue, showPicker: true });
        const newDate = (0, dateUtils_1.autocompleteDate)(newValue, format, locale);
        if (newDate && (0, date_fns_1.isValid)(newDate)) {
            this.setState({ navigationDate: newDate });
        }
        if (onValidationChanged) {
            onValidationChanged(this.computeError(newDate));
        }
        if (onChange) {
            onChange({ target: { value: this.computeDate(newDate) } });
        }
    }
    handleKeyDownIcon(e) {
        const { showPicker } = this.state;
        switch (e.key) {
            case eventUtils_1.Keys.TAB:
                if (!e.shiftKey && showPicker && this.refPicker) {
                    (0, eventUtils_1.cancelEvent)(e);
                    const elCell = this.refPicker.dayPicker.querySelector('.tk-daypicker-day[tabindex="0"]');
                    if (elCell) {
                        elCell.focus();
                    }
                }
                break;
            case eventUtils_1.Keys.SPACE:
            case eventUtils_1.Keys.SPACEBAR:
            case eventUtils_1.Keys.ENTER:
                (0, eventUtils_1.cancelEvent)(e);
                this.handleClickIcon();
                break;
            case eventUtils_1.Keys.ESC:
                if (showPicker) {
                    (0, eventUtils_1.cancelEvent)(e);
                    this.handleOnClose();
                }
                break;
            default:
                break;
        }
    }
    handleKeyDownInput(e) {
        const { showPicker } = this.state;
        switch (e.key) {
            case eventUtils_1.Keys.ENTER:
                (0, eventUtils_1.cancelEvent)(e);
                this.setState({ showPicker: !showPicker });
                break;
            case eventUtils_1.Keys.ESC:
                (0, eventUtils_1.cancelEvent)(e);
                this.setState({ showPicker: false });
                break;
            case eventUtils_1.Keys.TAB:
                this.setState({ showPicker: false });
                break;
            default:
                break;
        }
    }
    handleClickIcon() {
        const { showPicker } = this.state;
        this.setState({ showPicker: !showPicker });
    }
    handleOnClose() {
        const { refIcon } = this.state;
        this.setState({ showPicker: false });
        if (refIcon.current) {
            refIcon.current.focus();
        }
    }
    renderCalendar() {
        const { date, disabledDays, dir, highlightedDays, label, labels, todayButton, ariaLabel, menuPortalTarget, menuPortalStyles, } = this.props;
        const { locale, navigationDate, showPicker } = this.state;
        const portalStyles = menuPortalTarget ? menuPortalStyles : undefined;
        return ((0, jsx_runtime_1.jsx)("div", { role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, ref: this.setPopperElement, className: "DatePickerContainer", style: Object.assign({ display: showPicker ? 'block' : 'none' }, portalStyles), children: (0, jsx_runtime_1.jsx)(DayPicker_1.default, { ref: (el) => (this.refPicker = el), "aria-labelledby": label, selectedDays: this.computeDate(date), disabledDays: disabledDays, dir: dir, highlightedDays: highlightedDays, locale: locale, month: navigationDate, todayButton: todayButton, labels: labels, dataTestId: `${this.props.id}_DAYPICKER`, onDayClick: this.handleDayClick, onClose: this.handleOnClose }) }));
    }
    render() {
        const { id, disabled, format, label, menuPortalTarget, name, placeholder, tooltip, tooltipCloseLabel, showRequired, helperText, onCopy, onCut, onDrag, onFocus, } = this.props;
        const { inputValue, showPicker, refIcon } = this.state;
        const textfieldProps = {
            id,
            disabled,
            helperText,
            label,
            name,
            placeholder: placeholder || format.toUpperCase(),
            tooltip,
            tooltipCloseLabel,
            showRequired,
            onCopy,
            onCut,
            onDrag,
            onFocus,
        };
        return ((0, jsx_runtime_1.jsxs)("div", { className: 'tk-datepicker', ref: this.setRefContainer, children: [(0, jsx_runtime_1.jsx)("div", { ref: this.setReferenceElement, children: (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, textfieldProps, { className: (0, clsx_1.clsx)({
                            active: showPicker,
                        }), rightDecorators: (0, jsx_runtime_1.jsx)(FontIcon_1.default, { className: (0, clsx_1.clsx)('tk-input__right-decorators__clickable', {
                                active: showPicker,
                            }), disabled: disabled, iconName: 'calendar', forwardRef: refIcon, tabIndex: 0, onClick: () => this.handleClickIcon(), onKeyDown: this.handleKeyDownIcon }), value: inputValue || '', onChange: this.handleInputChange, onClick: () => this.setState({ showPicker: true }), onKeyDown: this.handleKeyDownInput })) }), menuPortalTarget
                    ? (0, react_dom_1.createPortal)(this.renderCalendar(), menuPortalTarget)
                    : this.renderCalendar()] }));
    }
}
DatePicker.defaultProps = {
    dir: 'ltr',
    format: 'MM-dd-yyyy',
    labels: {
        previousYear: 'Previous Year',
        nextYear: 'Next Year',
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
    },
    placement: 'bottom',
    todayButton: 'Today',
    tooltipCloseLabel: 'Got it',
};
DatePicker.propTypes = {
    className: PropTypes.string,
    date: PropTypes.instanceOf(Date),
    format: PropTypes.string,
    dir: PropTypes.oneOf(['ltr', 'rtl']),
    disabled: PropTypes.bool,
    disabledDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
    highlightedDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
    initialMonth: PropTypes.instanceOf(Date),
    label: PropTypes.string,
    helperText: PropTypes.string,
    labels: PropTypes.exact({
        previousYear: PropTypes.string,
        previousMonth: PropTypes.string,
        nextYear: PropTypes.string,
        nextMonth: PropTypes.string,
    }),
    locale: PropTypes.string,
    name: PropTypes.string,
    onInit: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onValidationChanged: PropTypes.func,
    placeholder: PropTypes.string,
    placement: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
    todayButton: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipCloseLabel: PropTypes.string,
    showRequired: PropTypes.bool,
    showOverlay: PropTypes.bool
};
exports.default = DatePicker;
